export const returnToApplicationErrorMessages = [
  'There is already an account with that phone number.',
  'There is already an account with that email address.',
]
